import store from "@/config/vuex/store";

export default [
    {
        path: "/financeiro",
        component: () => import('@/pages/Layout/DashboardLayout'),
        children: [            
            {
                path: "repasse-analitico",
                name: "repasseAnaliticoRead",
                component: () => import('@/pages/Financeiro/RepasseAnaliticoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "repasse-sintetico",
                name: "repasseSinteticoRead",
                component: () => import('@/pages/Financeiro/RepasseSinteticoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "faturamento",
                name: "faturamentoRead",
                component: () => import('@/pages/Financeiro/FaturamentoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "faturamento-visualizar/:id",
                name: "faturamentoView",
                component: () => import('@/pages/Financeiro/FaturamentoView'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }
        ]
    }
]

